<template>
  <header class="header">
    <v-stepper v-model="step"
               class="header-stepper"
               alt-labels>

      <v-stepper-header>

        <v-stepper-step class="header-stepper-step"
                        step="1"
                        :editable="isFirstStepDone"
                        :complete="step > 1"
                        :edit-icon="$vuetify.icons.complete"
                        @click="emitStep({ step: 1, isDone: isFirstStepDone })">
            {{$t('message.marketingGenerics.message.content')}}
        </v-stepper-step>

        <v-divider></v-divider>

        <v-stepper-step class="header-stepper-step"
                        step="2"
                        :editable="isSecondStepDone"
                        :complete="step > 2"
                        :edit-icon="$vuetify.icons.complete"
                        @click="emitStep({ step: 2, isDone: isSecondStepDone })">
            {{$t('message.marketingGenerics.message.recipients')}}
        </v-stepper-step>

        <v-divider></v-divider>

        <v-stepper-step class="header-stepper-step"
                        step="3"
                        :editable="isThirdStepDone"
                        :complete="step > 3"
                        :edit-icon="$vuetify.icons.complete"
                        @click="emitStep({ step: 3, isDone: isThirdStepDone })">
            {{$t('message.marketingGenerics.message.send')}}
        </v-stepper-step>

      </v-stepper-header>
    </v-stepper>
  </header>
</template>

<script>
import EventBus from "@packages/event-bus";

export default {
  components: {},

  computed: {},

  data() {
    return {
      step: 1,
      isFirstStepDone: false,
      isSecondStepDone: false,
      isThirdStepDone: false,
    };
  },

  created() {
    EventBus.$on("SET_SMS_FORM_STEP", this.setStep);
  },

  methods: {
    setStep(stepVal) {
      this.step = stepVal;

      if (stepVal === 2) {
        this.isFirstStepDone = true;
      } else if (stepVal === 3) {
        this.isSecondStepDone = true;
      } else if (stepVal === 4) {
        this.isThirdStepDone = true;
      }
    },
    emitStep({ step, isDone }) {
      if (isDone) {
        EventBus.$emit("SET_SMS_FORM_STEP", step);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.header {
  .header-stepper {
    box-shadow: none;

    .header-stepper-step {
      ::v-deep .v-stepper__label {
        font-size: 14px;
        font-weight: 500;
      }      
    }
  }
}
</style>
